<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";

// import SmartNotifications from "@/components/tools/modals/SmartNotifications";
import Clicksign from "@/components/tools/modals/Clicksign.vue";
import ContaAzul from "@/components/tools/modals/ContaAzul.vue";
import DigitalManagerGuru from "@/components/tools/modals/DigitalManagerGuru.vue";
import FunnelControl from "@/components/tools/modals/FunnelControl.vue";
import Hotzapp from "@/components/tools/modals/Hotzapp.vue";
import Make from "@/components/tools/modals/Make.vue";
import Telegram from "@/components/tools/modals/Telegram.vue";
import Utmify from "@/components/tools/modals/Utmify.vue";
import Voxuy from "@/components/tools/modals/Voxuy.vue";
import Zapier from "@/components/tools/modals/Zapier.vue";

export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Automações",
      subtitle: "Integre suas ferramentas de automação à Blitzpay."
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Voxuy",
          image: require("@/assets/images/integrations/voxuy.svg"),
          description: "Integre sua conta da Voxuy à Blitzpay.",
          modal: Voxuy,
          name: "voxuy"
        },
        {
          title: "Hotzapp",
          image: require("@/assets/images/integrations/hotzapp.svg"),
          description: "Integre sua conta da Hotzapp à Blitzpay.",
          modal: Hotzapp,
          name: "hotzapp"
        },
        {
          title: "Telegram",
          image: require("@/assets/images/integrations/telegram.svg"),
          description: "Integre seus chats do Telegram à Blitzpay.",
          modal: Telegram,
          name: "telegram"
        },
        {
          title: "Make",
          image: require("@/assets/images/integrations/make.svg"),
          description: "Integre sua conta da Make à Blitzpay.",
          modal: Make,
          name: "make"
        },
        {
          title: "Zapier",
          image: require("@/assets/images/integrations/zapier.svg"),
          description: "Integre sua conta da Zapier à Blitzpay.",
          modal: Zapier,
          name: "zapier"
        },
        // {
        //   title: "Notificações Inteligentes",
        //   image: require("@/assets/images/integrations/smart-notifications.svg"),
        //   description:
        //     "Integre sua conta da Notificações Inteligentes à Blitzpay.",
        //   modal: SmartNotifications,
        //   name: "smart-notifications"
        // },
        {
          title: "Clicksign",
          image: require("@/assets/images/integrations/clicksign.svg"),
          description: "Integre sua conta da Clicksign à Blitzpay.",
          modal: Clicksign,
          name: "clicksign"
        },
        {
          title: "Funnel Control",
          image: require("@/assets/images/integrations/funnel-control.svg"),
          description: "Integre sua conta da Funnel Control à Blitzpay.",
          modal: FunnelControl,
          name: "funnel-control"
        },
        {
          title: "Digital Manager Guru",
          image: require("@/assets/images/integrations/digital-manager-guru.svg"),
          description:
            "Integre sua área de membros da plataforma Digital Manager Guru à Blitzpay.",
          modal: DigitalManagerGuru,
          name: "digital-manager-guru"
        },
        {
          title: "Conta Azul",
          image: require("@/assets/images/integrations/conta-azul.svg"),
          description: "Integre sua conta da Conta Azul à Blitzpay.",
          modal: ContaAzul,
          name: "conta-azul"
        },
        {
          title: "Utmify",
          image: require("@/assets/images/integrations/utmify.svg"),
          description: "Integre sua conta da Utmify à Blitzpay.",
          modal: Utmify,
          name: "utmify"
        }
      ];
    }
  }
};
</script>
